import { render, staticRenderFns } from "./MealType.vue?vue&type=template&id=f0aac2e8&"
import script from "./MealType.vue?vue&type=script&lang=js&"
export * from "./MealType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports